var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlertDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34.064 26.308-12.075-21a4.5 4.5 0 0 0-7.86 0l-12 21a4.5 4.5 0 0 0 3.84 6.795h24.18a4.499 4.499 0 0 0 3.915-6.795z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.99 5.308 12.074 21a4.5 4.5 0 0 1-3.915 6.795H5.97a4.5 4.5 0 0 1-3.84-6.795l12-21a4.5 4.5 0 0 1 7.86 0zm-4.823 19.048a1.5 1.5 0 1 1 1.666 2.495 1.5 1.5 0 0 1-1.666-2.495zm-.228-11.814a1.5 1.5 0 0 1 2.561 1.061v6a1.5 1.5 0 1 1-3 0v-6c0-.398.158-.78.44-1.06z",
    fill: "#F95A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertDelete);
export default __webpack_public_path__ + "static/media/IconAlertDelete.44c99720da7b8203137540490b8a9c31.svg";
export { ForwardRef as ReactComponent };